import { useMemo } from "react";

function directIframeSrc(code) {
  const doc = new DOMParser().parseFromString(code, "text/html");
  const frames = doc.querySelectorAll("iframe");
  if (frames.length !== 1 || doc.querySelector("script")) return null;
  const src = frames[0].getAttribute("src") || "";
  return src.startsWith("https://") ? src : null;
}

export const EmbedFrame = ({ embed }) => {
  const src = useMemo(() => directIframeSrc(embed.code), [embed.code]);
  const common = {
    title: embed.title,
    style: { height: embed.height },
    className: "w-full rounded-lg border border-white/10 bg-white",
    "data-testid": `embed-frame-${embed.id || "preview"}`,
  };
  if (src) return <iframe {...common} src={src} loading="lazy" allow="clipboard-write" />;
  const doc = `<!doctype html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><base target="_blank"><style>body{margin:0;padding:12px;font-family:system-ui,sans-serif}</style></head><body>${embed.code}</body></html>`;
  return <iframe {...common} srcDoc={doc} sandbox="allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox" />;
};

export const EmbedCard = ({ embed }) => (
  <div className="rounded-lg border border-white/[0.08] bg-[#111827] p-5 sm:p-6" data-testid={`embed-card-${embed.id}`}>
    <h3 className="font-display text-2xl font-bold uppercase text-white">{embed.title}</h3>
    {embed.description && <p className="mb-4 mt-1 text-sm text-slate-400">{embed.description}</p>}
    <div className={embed.description ? "" : "mt-4"}><EmbedFrame embed={embed} /></div>
  </div>
);
